// Notification enums
export enum NotificationType {
  // Task notifications
  TASK_ASSIGNED = 'TASK_ASSIGNED',
  TASK_STATUS_CHANGED = 'TASK_STATUS_CHANGED',
  TASK_DUE_SOON = 'TASK_DUE_SOON',
  TASK_OVERDUE = 'TASK_OVERDUE',
  TASK_SLA_BREACHED = 'TASK_SLA_BREACHED',
  TASK_COMMENT_ADDED = 'TASK_COMMENT_ADDED',
  TASK_PRIORITY_CHANGED = 'TASK_PRIORITY_CHANGED',
  TASK_MENTION = 'TASK_MENTION',

  // Ticket notifications
  TICKET_CREATED = 'TICKET_CREATED',
  TICKET_ASSIGNED = 'TICKET_ASSIGNED',
  TICKET_FOLLOWED = 'TICKET_FOLLOWED',
  TICKET_UPDATED = 'TICKET_UPDATED',
  TICKET_STATUS_CHANGED = 'TICKET_STATUS_CHANGED',
  TICKET_COMMENT_ADDED = 'TICKET_COMMENT_ADDED',
  TICKET_MENTION = 'TICKET_MENTION',
  // A customer replied on their ticket, by inbound email or through the
  // client portal. Separate from TICKET_COMMENT_ADDED (staff-side comments)
  // and TICKET_UPDATED (agent field edits, which SLA alerts ride on).
  TICKET_CUSTOMER_REPLY = 'TICKET_CUSTOMER_REPLY',

  // Comment/Thread notifications
  COMMENT_MENTION = 'COMMENT_MENTION',
  COMMENT_REPLY = 'COMMENT_REPLY',
  COMMENT_REACTION = 'COMMENT_REACTION',
  THREAD_MESSAGE = 'THREAD_MESSAGE',

  // Project notifications
  PROJECT_MEMBER_ADDED = 'PROJECT_MEMBER_ADDED',
  PROJECT_MEMBER_REMOVED = 'PROJECT_MEMBER_REMOVED',
  PROJECT_STATUS_CHANGED = 'PROJECT_STATUS_CHANGED',
  PROJECT_DUE_SOON = 'PROJECT_DUE_SOON',

  // Project watcher notifications (category-level; the specific event is in data.watchEvent)
  PROJECT_WATCH_TASK_ACTIVITY = 'PROJECT_WATCH_TASK_ACTIVITY',
  PROJECT_WATCH_COMMENTS = 'PROJECT_WATCH_COMMENTS',
  PROJECT_WATCH_DOCUMENTS = 'PROJECT_WATCH_DOCUMENTS',
  PROJECT_WATCH_PROJECT_CHANGES = 'PROJECT_WATCH_PROJECT_CHANGES',

  // Invoice notifications
  INVOICE_SENT = 'INVOICE_SENT',
  INVOICE_OPENED = 'INVOICE_OPENED',
  INVOICE_PAYMENT_RECORDED = 'INVOICE_PAYMENT_RECORDED',
  INVOICE_OVERDUE = 'INVOICE_OVERDUE',
  // Online (Stripe) payments: a client's payment failed, or money arrived that
  // could not be applied to the balance (paid after void / overpayment / dispute).
  INVOICE_PAYMENT_FAILED = 'INVOICE_PAYMENT_FAILED',
  INVOICE_PAYMENT_NEEDS_REVIEW = 'INVOICE_PAYMENT_NEEDS_REVIEW',

  // Sprint notifications
  SPRINT_STARTED = 'SPRINT_STARTED',
  SPRINT_COMPLETED = 'SPRINT_COMPLETED',

  // System notifications
  SUBSCRIPTION_EXPIRING = 'SUBSCRIPTION_EXPIRING',
  SUBSCRIPTION_RENEWED = 'SUBSCRIPTION_RENEWED',
  FEATURE_ANNOUNCEMENT = 'FEATURE_ANNOUNCEMENT',
  SYSTEM_MAINTENANCE = 'SYSTEM_MAINTENANCE',

  // Entity notifications
  ENTITY_MEMBER_ADDED = 'ENTITY_MEMBER_ADDED',
  ENTITY_STATUS_CHANGED = 'ENTITY_STATUS_CHANGED',

  // Deal/Contact notifications
  DEAL_ASSIGNED = 'DEAL_ASSIGNED',
  DEAL_STATUS_CHANGED = 'DEAL_STATUS_CHANGED',
  CONTACT_ASSIGNED = 'CONTACT_ASSIGNED',
  CONTACT_UPDATED = 'CONTACT_UPDATED',

  // Note notifications
  NOTE_MENTION = 'NOTE_MENTION',
  CLIENT_PORTAL_NOTE_SHARED = 'CLIENT_PORTAL_NOTE_SHARED',

  // Client portal notifications
  CLIENT_PORTAL_TASK_READY = 'CLIENT_PORTAL_TASK_READY',

  // Meeting recording notifications
  MEETING_NOTES_READY = 'MEETING_NOTES_READY',
  MEETING_NOTES_FAILED = 'MEETING_NOTES_FAILED',

  // Import notifications
  IMPORT_COMPLETED = 'IMPORT_COMPLETED',
  IMPORT_FAILED = 'IMPORT_FAILED',

  // Demand notifications
  DEMAND_SUBMITTED = 'DEMAND_SUBMITTED',
  DEMAND_TRIAGED = 'DEMAND_TRIAGED',
  DEMAND_MATCH_AVAILABLE = 'DEMAND_MATCH_AVAILABLE',
  DEMAND_FULFILLED = 'DEMAND_FULFILLED',
  DEMAND_RETURNED_TO_ACTIVE = 'DEMAND_RETURNED_TO_ACTIVE',
  DEMAND_APPROACHING_START = 'DEMAND_APPROACHING_START',
  DEMAND_DEAL_STATUS_CHANGED = 'DEMAND_DEAL_STATUS_CHANGED',

  // Burnout notifications (Plan 9b)
  BURNOUT_RISK_TRANSITION = 'BURNOUT_RISK_TRANSITION',

  // Resource notifications
  RESOURCE_WEEKLY_DIGEST = 'RESOURCE_WEEKLY_DIGEST',

  // Timesheet notifications
  TIMESHEET_ENTRY_SUBMITTED = 'TIMESHEET_ENTRY_SUBMITTED',
  TIMESHEET_ENTRY_APPROVED = 'TIMESHEET_ENTRY_APPROVED',
  TIMESHEET_ENTRY_REJECTED = 'TIMESHEET_ENTRY_REJECTED',
  TIMESHEET_ENTRY_CHANGES_REQUESTED = 'TIMESHEET_ENTRY_CHANGES_REQUESTED',
  TIMESHEET_SUBMITTED = 'TIMESHEET_SUBMITTED',
  TIMESHEET_APPROVED = 'TIMESHEET_APPROVED',
  TIMESHEET_REJECTED = 'TIMESHEET_REJECTED',
  TIMESHEET_CHANGES_REQUESTED = 'TIMESHEET_CHANGES_REQUESTED',
  TIMESHEET_CLOSE_REMINDER = 'TIMESHEET_CLOSE_REMINDER',
  TIMESHEET_MISSING_REMINDER = 'TIMESHEET_MISSING_REMINDER',
  TIMESHEET_APPROVAL_DEADLINE = 'TIMESHEET_APPROVAL_DEADLINE',

  // Time entry tagging (suggestions)
  TIME_ENTRY_TAGGED = 'TIME_ENTRY_TAGGED',

  // Budget change requests + alerts (Phase 4 of the budgeting rework)
  BUDGET_CHANGE_REQUESTED = 'BUDGET_CHANGE_REQUESTED',
  BUDGET_CHANGE_APPROVED = 'BUDGET_CHANGE_APPROVED',
  BUDGET_CHANGE_REJECTED = 'BUDGET_CHANGE_REJECTED',
  BUDGET_USAGE_70 = 'BUDGET_USAGE_70',
  BUDGET_USAGE_90 = 'BUDGET_USAGE_90',
  BUDGET_OVERAGE = 'BUDGET_OVERAGE',
  BUDGET_PROJECTED_OVERAGE = 'BUDGET_PROJECTED_OVERAGE',

  // Contract approval requests (contract.settings.requireApproval gate)
  CONTRACT_APPROVAL_REQUESTED = 'CONTRACT_APPROVAL_REQUESTED',
  CONTRACT_APPROVAL_APPROVED = 'CONTRACT_APPROVAL_APPROVED',
  CONTRACT_APPROVAL_REJECTED = 'CONTRACT_APPROVAL_REJECTED',
  // Client-portal invoice approval (client-portal-financials Phase 2).
  // REQUESTED goes to portal approvers; APPROVED / CHANGES_REQUESTED are
  // staff-facing and deliberately absent from CLIENT_PORTAL_NOTIFICATION_TYPES.
  INVOICE_APPROVAL_REQUESTED = 'INVOICE_APPROVAL_REQUESTED',
  INVOICE_APPROVAL_APPROVED = 'INVOICE_APPROVAL_APPROVED',
  INVOICE_APPROVAL_CHANGES_REQUESTED = 'INVOICE_APPROVAL_CHANGES_REQUESTED',
  // Monthly client billing review (invoicing-ops Phase 4): fired once when a
  // review passes its due date unfinished, to its assigned reviewer only.
  CLIENT_BILLING_REVIEW_OVERDUE = 'CLIENT_BILLING_REVIEW_OVERDUE',

  // Client authorization alerts (billing schedule pass Phase 2.6)
  AUTHORIZATION_EXPIRING = 'AUTHORIZATION_EXPIRING',
  AUTHORIZATION_LOW_REMAINING = 'AUTHORIZATION_LOW_REMAINING',
  // Client authorization lifecycle (SD-123): created, material change
  // (amount, dates, status incl. approval), and consumption crossing 100%.
  AUTHORIZATION_CREATED = 'AUTHORIZATION_CREATED',
  AUTHORIZATION_UPDATED = 'AUTHORIZATION_UPDATED',
  AUTHORIZATION_EXCEEDED = 'AUTHORIZATION_EXCEEDED',

  // Client health notifications
  ENTITY_HEALTH_AT_RISK = 'ENTITY_HEALTH_AT_RISK',
  ENTITY_HEALTH_DECLINED = 'ENTITY_HEALTH_DECLINED',
  ENTITY_HEALTH_IMPROVED = 'ENTITY_HEALTH_IMPROVED',
  DEAL_HEALTH_AT_RISK = 'DEAL_HEALTH_AT_RISK',

  // Lifecycle automation notifications
  LIFECYCLE_STAGE_AUTOMATED = 'LIFECYCLE_STAGE_AUTOMATED',

  // Agent review notifications
  AGENT_REVIEW_REQUESTED = 'AGENT_REVIEW_REQUESTED',

  // Benny runs (background tasks) — to the person who handed Benny the task
  BENNY_RUN_NEEDS_APPROVAL = 'BENNY_RUN_NEEDS_APPROVAL',
  BENNY_RUN_COMPLETED = 'BENNY_RUN_COMPLETED',
  BENNY_RUN_FAILED = 'BENNY_RUN_FAILED',

  // Bring Your Own AI — to org owners/admins when the provider key stops working
  AI_PROVIDER_KEY_INVALID = 'AI_PROVIDER_KEY_INVALID',

  // Personal accounts (family daily-habit loop)
  STREAK_MILESTONE = 'STREAK_MILESTONE',
  LIST_THRESHOLD = 'LIST_THRESHOLD',

  // Date-driven reminders (collection date fields, contact birthdays)
  COLLECTION_DATE_REMINDER = 'COLLECTION_DATE_REMINDER',
  BIRTHDAY_REMINDER = 'BIRTHDAY_REMINDER',

  // Weekly family stars recap (personal spaces)
  STARS_WEEKLY_SUMMARY = 'STARS_WEEKLY_SUMMARY',

  // Work-account engagement: badges, weekly goals, weekly recap (to the user)
  ACHIEVEMENT_UNLOCKED = 'ACHIEVEMENT_UNLOCKED',
  GOAL_ACHIEVED = 'GOAL_ACHIEVED',
  ENGAGEMENT_WEEKLY_RECAP = 'ENGAGEMENT_WEEKLY_RECAP',

  // Contract lifecycle alert sweep (G1): term end approaching, month-to-month
  // past its end date, billing schedule lines coming due
  CONTRACT_TERM_ENDING = 'CONTRACT_TERM_ENDING',
  CONTRACT_MONTH_TO_MONTH_ACTIVE = 'CONTRACT_MONTH_TO_MONTH_ACTIVE',
  CONTRACT_SCHEDULE_LINE_DUE = 'CONTRACT_SCHEDULE_LINE_DUE',

  // General
  CUSTOM = 'CUSTOM',
}

export enum NotificationPriority {
  LOW = 'LOW',
  NORMAL = 'NORMAL',
  HIGH = 'HIGH',
  URGENT = 'URGENT',
}

export enum NotificationStatus {
  UNREAD = 'UNREAD',
  READ = 'READ',
  DISMISSED = 'DISMISSED',
  ARCHIVED = 'ARCHIVED',
}

export enum NotificationChannel {
  IN_APP = 'IN_APP',
  EMAIL = 'EMAIL',
  PUSH = 'PUSH',
  SMS = 'SMS',
  SLACK = 'SLACK',
  WEBHOOK = 'WEBHOOK',
}

// Base notification interface
export interface Notification {
  id: string
  organizationId: string
  recipientId: string
  type: NotificationType
  title: string
  message?: string | null
  data?: any
  entityType?: string | null
  entityId?: string | null
  actorId?: string | null
  priority: NotificationPriority
  status: NotificationStatus
  readAt?: Date | null
  dismissedAt?: Date | null
  createdAt: Date
  updatedAt: Date
  expiresAt?: Date | null

  // Living-notification fields: re-emits coalesce onto one row and bump these
  unreadMessageCount?: number
  lastMessageAt?: Date | null
  lastActorId?: string | null

  // Populated relations
  actor?: {
    id: string
    firstName?: string | null
    lastName?: string | null
    displayName?: string | null
    email: string
    image?: string | null
  }
}

/** Written into `data.resolution` when a notification auto-resolves. */
export interface NotificationResolution {
  outcome: string
  resolvedBy?: string | null
  resolvedAt: string
  auto: boolean
}

// ===== Notification feed (lane-based) =====

/** Types that represent something waiting on the recipient to act. */
export const NOTIFICATION_ACTION_TYPES: NotificationType[] = [
  NotificationType.TIMESHEET_APPROVAL_DEADLINE,
  NotificationType.TIMESHEET_SUBMITTED,
  NotificationType.TIMESHEET_ENTRY_SUBMITTED,
  NotificationType.TIMESHEET_CLOSE_REMINDER,
  NotificationType.TIMESHEET_MISSING_REMINDER,
  NotificationType.TASK_OVERDUE,
  NotificationType.TASK_DUE_SOON,
  NotificationType.TASK_SLA_BREACHED,
  NotificationType.AGENT_REVIEW_REQUESTED,
  NotificationType.BENNY_RUN_NEEDS_APPROVAL,
  NotificationType.AI_PROVIDER_KEY_INVALID,
  NotificationType.BUDGET_CHANGE_REQUESTED,
  NotificationType.CONTRACT_APPROVAL_REQUESTED,
  NotificationType.INVOICE_APPROVAL_REQUESTED,
]

/** Types where someone is speaking directly to the recipient. */
export const NOTIFICATION_MENTION_TYPES: NotificationType[] = [
  NotificationType.TASK_MENTION,
  NotificationType.COMMENT_MENTION,
  NotificationType.NOTE_MENTION,
  NotificationType.TICKET_MENTION,
  NotificationType.COMMENT_REPLY,
]

/**
 * Types a client portal user can receive in-app. Delivery to users without an
 * org membership (portal-only recipients) is limited to this set.
 */
export const CLIENT_PORTAL_NOTIFICATION_TYPES: NotificationType[] = [
  NotificationType.TASK_MENTION,
  NotificationType.COMMENT_MENTION,
  NotificationType.COMMENT_REPLY,
  NotificationType.NOTE_MENTION,
  NotificationType.TICKET_MENTION,
  NotificationType.THREAD_MESSAGE,
  NotificationType.CLIENT_PORTAL_NOTE_SHARED,
  NotificationType.CLIENT_PORTAL_TASK_READY,
  NotificationType.TASK_ASSIGNED,
  NotificationType.TASK_STATUS_CHANGED,
  NotificationType.TASK_COMMENT_ADDED,
  NotificationType.TICKET_CREATED,
  NotificationType.TICKET_UPDATED,
  NotificationType.TICKET_STATUS_CHANGED,
  NotificationType.TICKET_COMMENT_ADDED,
  NotificationType.INVOICE_APPROVAL_REQUESTED,
]

/**
 * Subset of portal types that may go out by email. TICKET_COMMENT_ADDED is
 * deliberately excluded: staff ticket replies already email the requester via
 * the outbound ticket email path, so a notification email would double-send.
 */
export const CLIENT_PORTAL_EMAIL_NOTIFICATION_TYPES: NotificationType[] = [
  NotificationType.TASK_MENTION,
  NotificationType.COMMENT_MENTION,
  NotificationType.COMMENT_REPLY,
  NotificationType.NOTE_MENTION,
  NotificationType.TICKET_MENTION,
  NotificationType.THREAD_MESSAGE,
  NotificationType.CLIENT_PORTAL_NOTE_SHARED,
  NotificationType.CLIENT_PORTAL_TASK_READY,
]

// ===== Channel defaults =====

/**
 * Types that send email when the user has no explicit preference row. Kept
 * deliberately short — everything else is opt-in, because unsolicited email is
 * how people learn to ignore the app entirely.
 */
export const EMAIL_DEFAULT_ON_NOTIFICATION_TYPES: NotificationType[] = [
  NotificationType.TASK_ASSIGNED,
  NotificationType.TASK_OVERDUE,
  NotificationType.TICKET_CREATED,
  NotificationType.TICKET_ASSIGNED,
  NotificationType.TICKET_CUSTOMER_REPLY,
  NotificationType.COMMENT_MENTION,
  NotificationType.NOTE_MENTION,
  NotificationType.PROJECT_MEMBER_ADDED,
  NotificationType.INVOICE_OVERDUE,
  // Fire-once per review, addressed to its assigned reviewer only: low volume,
  // high value, mirrors INVOICE_OVERDUE.
  NotificationType.CLIENT_BILLING_REVIEW_OVERDUE,
  NotificationType.SUBSCRIPTION_EXPIRING,
  NotificationType.SYSTEM_MAINTENANCE,
  // Contract lifecycle alerts: low-volume (fire-once per contract per window)
  // and high-value; the schedule-line type stays email-off.
  NotificationType.CONTRACT_TERM_ENDING,
  NotificationType.CONTRACT_MONTH_TO_MONTH_ACTIVE,
  // Portal-only types. Staff never receive these, so staff email defaults are
  // unaffected; delivery additionally caps portal recipients to
  // CLIENT_PORTAL_EMAIL_NOTIFICATION_TYPES.
  NotificationType.CLIENT_PORTAL_TASK_READY,
  NotificationType.CLIENT_PORTAL_NOTE_SHARED,
]

/** Types that push to a device when the user has no explicit preference row. */
export const PUSH_DEFAULT_ON_NOTIFICATION_TYPES: NotificationType[] = [
  NotificationType.TASK_ASSIGNED,
  NotificationType.TASK_OVERDUE,
  NotificationType.TASK_DUE_SOON,
  NotificationType.COMMENT_MENTION,
  NotificationType.NOTE_MENTION,
]

/**
 * Does this channel/type combination default to on when the user has no
 * preference row? The single source of truth for both the API's resolution
 * (NotificationPreferencesService) and the settings UI's unset state — they
 * used to keep separate copies and had already drifted apart.
 *
 * IN_APP is on for everything: it is also the gate that decides whether a
 * notification row is written at all, so turning it off silences every other
 * channel for that type.
 */
export function isNotificationChannelDefaultEnabled(
  channel: string,
  type: string,
): boolean {
  if (channel === NotificationChannel.IN_APP) return true
  if (channel === NotificationChannel.EMAIL) {
    return EMAIL_DEFAULT_ON_NOTIFICATION_TYPES.includes(
      type as NotificationType,
    )
  }
  if (channel === NotificationChannel.PUSH) {
    return PUSH_DEFAULT_ON_NOTIFICATION_TYPES.includes(type as NotificationType)
  }
  return false
}

export interface NotificationFeedCounts {
  /** Unresolved action items (any read state) — drives the red badge */
  actionRequired: number
  /** Unread mentions — drives the blue badge */
  mentions: number
  /** Raw unread, for completeness */
  unread: number
}

export interface NotificationFeedResponse {
  /** Unresolved action items, most urgent first */
  actionRequired: Notification[]
  /** Unread mentions, newest first */
  mentions: Notification[]
  /** Everything else (including recently resolved), newest first */
  activity: Notification[]
  counts: NotificationFeedCounts
  /** Notifications auto-resolved in the last 24h */
  resolvedToday: number
}

/**
 * Per-record rollup of the current user's unread notifications — powers the
 * unread-activity dots on work-list rows.
 */
export interface UnreadEntitySummary {
  entityType: 'TASK' | 'TICKET'
  entityId: string
  /** Total unread events (coalesced rows count via unreadMessageCount) */
  count: number
  /** Distinct notification types contributing to the rollup */
  types: NotificationType[]
  /** Backing notification ids, so opening the record can mark them read */
  notificationIds: string[]
  lastActivityAt: Date | string
}

export interface UnreadEntitiesResponse {
  entities: UnreadEntitySummary[]
}

// Notification preference interface
export interface NotificationPreference {
  id: string
  userId: string
  organizationId: string
  channel: NotificationChannel
  type: NotificationType
  enabled: boolean
  createdAt: Date
  updatedAt: Date
}

// Notification template interface
export interface NotificationTemplate {
  id: string
  organizationId?: string | null
  type: NotificationType
  channel: NotificationChannel
  name: string
  subject?: string | null
  template: string
  variables?: any
  isActive: boolean
  createdAt: Date
  updatedAt: Date
}

export interface PushToken {
  id: string
  userId: string
  token: string
  deviceId?: string | null
  platform?: string | null
  appVersion?: string | null
  lastSeenAt: Date
  createdAt: Date
  updatedAt: Date
}

// Notification creation DTOs
export interface CreateNotificationDto {
  recipientId: string
  type: NotificationType
  title: string
  message?: string
  data?: any
  entityType?: string
  entityId?: string
  actorId?: string
  priority?: NotificationPriority
  expiresAt?: Date
}

export interface BulkCreateNotificationDto {
  recipientIds: string[]
  type: NotificationType
  title: string
  message?: string
  data?: any
  entityType?: string
  entityId?: string
  actorId?: string
  priority?: NotificationPriority
  expiresAt?: Date
}

// Notification update DTOs
export interface UpdateNotificationDto {
  status?: NotificationStatus
  readAt?: Date
  dismissedAt?: Date
}

export interface MarkNotificationsReadDto {
  notificationIds: string[]
}

// Notification preference DTOs
export interface UpdateNotificationPreferenceDto {
  channel: NotificationChannel
  type: NotificationType
  enabled: boolean
}

export interface BulkUpdateNotificationPreferencesDto {
  preferences: UpdateNotificationPreferenceDto[]
}

export interface RegisterPushTokenDto {
  token: string
  deviceId?: string
  platform?: string
  appVersion?: string
}

export interface UnregisterPushTokenDto {
  token: string
}

// Notification query DTOs
export interface NotificationQueryDto {
  status?: NotificationStatus
  type?: NotificationType
  /** Multi-select type filter. Comma-serialized on the wire. */
  types?: NotificationType[]
  priority?: NotificationPriority
  entityType?: string
  entityId?: string
  /** Free-text search across notification title and message. */
  search?: string
  startDate?: Date
  endDate?: Date
  page?: number
  limit?: number
  sortBy?: 'createdAt' | 'priority' | 'status'
  sortOrder?: 'asc' | 'desc'
}

// Notification summary
export interface NotificationSummary {
  total: number
  unread: number
  byType: Record<NotificationType, number>
  byPriority: Record<NotificationPriority, number>
}

// WebSocket event payloads
export interface NotificationCreatedPayload {
  notification: Notification
}

export interface NotificationUpdatedPayload {
  notificationId: string
  updates: Partial<Notification>
}

export interface NotificationDeletedPayload {
  notificationId: string
}

export interface UnreadCountUpdatedPayload {
  count: number
  organizationId: string
  userId: string
}

// Notification context data types
export interface TaskNotificationData {
  taskId: string
  taskName: string
  projectId?: string
  projectName?: string
  previousStatus?: string
  newStatus?: string
  dueDate?: Date
  assigneeId?: string
  assigneeName?: string
}

export interface CommentNotificationData {
  commentId: string
  threadId: string
  threadTitle?: string
  entityType: string
  entityId: string
  mentionedUsers?: string[]
}

export interface ProjectNotificationData {
  projectId: string
  projectName: string
  memberRole?: string
  previousStatus?: string
  newStatus?: string
}

export interface NoteNotificationData {
  noteId: string
  noteTitle: string
  contentSnippet?: string
  mentionedUsers?: string[]
}

export interface SystemNotificationData {
  action: string
  details?: any
  url?: string
}

// Notification action types
export interface NotificationAction {
  label: string
  url?: string
  action?: string
  primary?: boolean
}

// Enhanced notification with actions
export interface NotificationWithActions extends Notification {
  actions?: NotificationAction[]
}

// Plan 9b: Burnout risk transition notification payload
export interface BurnoutRiskTransitionData {
  memberId: string
  memberName: string
  fromLevel: string
  toLevel: string
  streakWeeks: number
  currentUtilizationPct: number
}
